$(function () {

    $('[data-toggle="tooltip"]').tooltip();

    $('.btn-aceptar').click(function () {
        let id = $(this).data('id');
        let nombre = $(this).data('nombre');

        swal.fire({
            title: '¿Aceptar postulante ' + nombre + '?',
            text: 'Esta acción confirmará la postulación del candidato.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, aceptar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33'
        }).then((result) => {
            if (result.isConfirmed) {
                $(".loader_").addClass("loading");
                $.ajax({
                    url: '/admin/postulaciones/aceptar/' + id,
                    type: 'GET',
                    success: function (resp) {
                        $(".loader_").removeClass("loading");
                        swal.fire({
                            icon: 'success',
                            //title: 'Postulación aceptada',
                            text: resp.message,
                            confirmButtonText: 'Aceptar',
                            confirmButtonColor: '#28a745',
                            showConfirmButton: true,
                            allowOutsideClick: true
                        }).then(() => {
                            location.reload();
                        });
                    },
                    error: function (xhr, status, errorThrown) {
                        $(".loader_").removeClass("loading");

                        let msg;

                        if (xhr.status === 422 && xhr.responseJSON?.message) {
                            msg = xhr.responseJSON.message;
                            swal.fire({icon: 'warning', title: 'Atención', text: msg, confirmButtonColor: '#d33'});
                        } else {
                            swal.fire({
                                icon: 'error', title: 'Error', text: 'No se pudo aceptar la postulación.',
                                confirmButtonColor: '#d33'
                            });
                        }
                    }
                });
            }
        });
    });

    $('.btn-validar').click(function () {
        let id = $(this).data('id');
        //$(".loader_").addClass("loading");

        $.ajax({
            url: '/admin/postulaciones/faltante/' + id,
            type: 'GET',
            success: function (resp) {
                //$(".loader_").removeClass("loading");
                $('#myModal').html(resp);
                $('#modalFaltante').modal('show');
            },
            error: function () {
                //$(".loader_").removeClass("loading");
                swal.fire('Error', 'No se pudo cargar la información.', 'error');
            }
        });
    });

    $(document).on('click', '#btnGuardarValidacion', function () {

        if ($('#formValidacion input[type="checkbox"]:checked').length === 0) {
            swal.fire('Atención', 'Debes marcar al menos una opción antes de guardar.', 'warning');
            return;
        }

        let formData = $('#formValidacion').serialize();
        $(".loader_").addClass("loading");

        $.ajax({
            url: '/admin/postulaciones/validar',
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: formData,
            success: function (resp) {
                $(".loader_").removeClass("loading");
                swal.fire({
                    icon: 'success',
                    //title: 'Notificación enviada',
                    text: resp.message,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#28a745'
                }).then(() => {
                    $('#modalFaltante').modal('hide');
                    location.reload();
                });
            },
            error: function () {
                $(".loader_").removeClass("loading");
                swal.fire('Error', 'No se pudo guardar la validación.', 'error');
            }
        });
    });

    //aceptar criba
    $('.btn-aceptar-criba').click(function () {

        let id = $(this).data('id');

        swal.fire({
            title: '¿Aceptar postulante?',
            text: 'Esta acción enviará a la siguiente etapa al postulante.',
            icon: 'question',
            input: 'textarea',
            inputLabel: 'Mensaje para el jurado',
            inputPlaceholder: 'Escribe el mensaje aquí...',
            inputAttributes: {
                'aria-label': 'Escribe el mensaje aquí'
            },
            showCancelButton: true,
            confirmButtonText: 'Sí, aceptar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            inputValidator: (value) => {
                if (!value) {
                    return 'Debes escribir un mensaje';
                }
            }
        }).then((result) => {

            if (result.isConfirmed) {

                let mensaje = result.value;

                $(".loader_").addClass("loading");

                $.ajax({
                    url: '/admin/postulaciones/aceptar/criba/' + id,
                    type: 'GET',
                    data: {
                        motivo_aceptacion: mensaje
                    },
                    success: function (resp) {

                        $(".loader_").removeClass("loading");

                        swal.fire({
                            icon: 'success',
                            text: resp.message,
                            confirmButtonText: 'Aceptar',
                            confirmButtonColor: '#28a745'
                        }).then(() => {
                            location.reload();
                        });
                    },
                    error: function () {
                        $(".loader_").removeClass("loading");
                        swal.fire('Error', 'No se pudo aceptar la postulación.', 'error');
                    }
                });
            }
        });
    });


    //rechazar
    $(document).on('click', '.btn-rechazar, .btn-rechazar-criba, .btn-rechazar-calificar', function () {
        let id = $(this).data('id');
        let nombre = $(this).data('nombre') ? ' ' + $(this).data('nombre') : '';
        //let nombre = $(this).data('nombre').trim();
        let tipo = '';

        if ($(this).hasClass('btn-rechazar-criba')) tipo = 'criba';
        else if ($(this).hasClass('btn-rechazar-calificar')) tipo = 'calificar';
        else tipo = 'normal';

        $('#postulanteId').val(id);
        $('#nombrePostulante').text(nombre);
        $('#motivoRechazo').val('');
        $('#rechazoTipo').val(tipo);

        $('#notificarPostulante').prop('checked', false);
        $('#modalRechazar').modal('show');
    });

    $('#btnConfirmarRechazo').click(function () {
        const id = $('#postulanteId').val();
        const tipo = $('#rechazoTipo').val();
        const motivo = $('#motivoRechazo').val().trim();
        const notificar = $('#notificarPostulante').is(':checked') ? true : false;

        if (motivo === '') {
            alert('Debes escribir un motivo de rechazo.');
            $('#motivoRechazo').focus();
            return;
        }

        if (motivo.length < 100) {
            alert('El motivo debe tener al menos 100 caracteres.');
            $('#motivoRechazo').focus();
            return;
        }

        let url = '/admin/postulaciones/rechazar/' + id;
        if (tipo === 'criba') url = '/admin/postulaciones/rechazar/criba/' + id;
        if (tipo === 'calificar') url = '/admin/postulaciones/rechazar/calificar/' + id;

        $(".loader_").addClass("loading");

        $.ajax({
            url: url,
            type: 'GET',
            data: {motivo: motivo, notificar: notificar},
            success: function (resp) {
                $(".loader_").removeClass("loading");
                $('#modalRechazar').modal('hide');
                swal.fire({
                    icon: 'success',
                    text: resp.message,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#28a745',
                }).then(() => {
                    location.reload();
                });
            },
            error: function () {
                $(".loader_").removeClass("loading");
                swal.fire('Error', 'No se pudo rechazar la postulación.', 'error');
            }
        });
    });

    //click al bonton limpiar
    $('#btnLimpiarBusqueda').on('click', function() {
        $('input[name="search"]').val('');
        $(this).closest('form').submit();
    });

    //si borran todo, para que no tengan que dar enter o al boton de buscar
    $('input[name="search"]').on('input', function() {
        if($(this).val() === '') {
            $(this).closest('form').submit();
        }
    });

});

